import React from "react";
import {
  Row,
  Label,
  Input,
  Form,
  FormGroup,
  FormFeedback,
  Button,
  Col,
  CardBody,
  Container,
  Card,
} from "reactstrap";
import { useFormik } from "formik";
import * as yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";

interface BasicInformationProps {
  onSubmit: (values: any) => void;
  onBack: () => void;
  data?: any;
}

const CheckInformation = ({
  onSubmit,
  onBack,
  data,
}: BasicInformationProps) => {
  //meta title
  document.title = "Ditobanx";

  const basicInfo = data.basicInfo;
  const identityInfo = data.identityInfo;
  const addressInfo = data.addressInfo;
  const financialInfo = data.financialInfo;

  let date_of_birth: any;
  if (identityInfo?.dateOfBirth) {
    date_of_birth = new Date(identityInfo?.dateOfBirth)
      .toISOString()
      .split("T")[0];
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      is_accepted_terms: false,
      privacy_policy_accepted: false,
    },
    validationSchema: yup.object().shape({
      is_accepted_terms: yup
        .boolean()
        .oneOf([true], "Debes aceptar los términos"),
      privacy_policy_accepted: yup
        .boolean()
        .oneOf([true], "Debes aceptar la política de privacidad"),
    }),
    onSubmit: (values) => {
      // console.log(values);
      onSubmit({
        is_accepted_terms: values.is_accepted_terms,
        privacy_policy_accepted: values.privacy_policy_accepted,
      });
    },
  });

  return (
    <React.Fragment>
      <Container className="mt-5">
        <Form onSubmit={validation.handleSubmit} autoComplete="off">
          <Card
            className="mt-4"
            style={{ backgroundColor: "#fff", borderRadius: "8px" }}
          >
            <CardBody>
              {/* Información Personal */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Información Personal</h5>
                  <p className="mb-1">
                    <strong>Nombre:</strong>{" "}
                    {basicInfo?.fullName || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Email:</strong>{" "}
                    {basicInfo?.email || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>País:</strong>{" "}
                    {basicInfo?.country || "No disponible"}
                  </p>
                </Col>
              </Row>

              {/* Verificación de Identidad */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Verificación de Identidad</h5>
                  <p className="mb-1">
                    <strong>Tipo de documento:</strong>{" "}
                    {identityInfo?.documentType || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Nacionalidad:</strong>{" "}
                    {identityInfo?.nacionality || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Fecha de nacimiento:</strong>{" "}
                    {date_of_birth || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Documento Frontal:</strong> Exitoso
                  </p>
                  <p className="mb-1">
                    <strong>Documento Dorso:</strong> Exitoso
                  </p>
                  <p className="mb-1">
                    <strong>Selfie:</strong> Exitoso
                  </p>
                </Col>
              </Row>

              {/* Información de Domicilio */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Información de Domicilio</h5>
                  <p className="mb-1">
                    <strong>Dirección:</strong>{" "}
                    {addressInfo?.address || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Ciudad o Estado:</strong>{" "}
                    {addressInfo?.city || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Código Postal:</strong>{" "}
                    {addressInfo?.postalCode || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Estado:</strong>{" "}
                    {addressInfo?.state || "No disponible"}
                  </p>
                </Col>
              </Row>

              {/* Información Financiera */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <h5 className="mb-3">Información Financiera</h5>
                  <p className="mb-1">
                    <strong>Actividad Económica / Giro:</strong>{" "}
                    {financialInfo?.economicActivity || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Ingreso Mensual:</strong>{" "}
                    {financialInfo?.income || "No disponible"}
                  </p>
                  <p className="mb-1">
                    <strong>Origen de fondos:</strong>{" "}
                    {financialInfo?.sourceOfFunds || "No disponible"}
                  </p>
                </Col>
              </Row>

              {/* Checkboxes */}
              <Row className="mb-4">
                <Col
                  style={{
                    backgroundColor: "#f7f7f7",
                    padding: "20px",
                    borderRadius: "8px",
                  }}
                >
                  <FormGroup check className="mb-2">
                    <Label check>
                      <Input
                        type="checkbox"
                        name="is_accepted_terms"
                        id="is_accepted_terms"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        checked={validation.values.is_accepted_terms}
                        invalid={
                          validation.touched.is_accepted_terms &&
                          !!validation.errors.is_accepted_terms
                        }
                      />
                      &nbsp; Acepto los{" "}
                      <a
                        href="https://ditobanx.com/terminos-y-condiciones/"
                        target="blank"
                      >
                        términos y condiciones{" "}
                      </a>
                      del servicio
                      {validation.touched.is_accepted_terms &&
                      validation.errors.is_accepted_terms ? (
                        <FormFeedback type="invalid">
                          {validation.errors.is_accepted_terms}
                        </FormFeedback>
                      ) : null}
                    </Label>
                  </FormGroup>
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        name="privacy_policy_accepted"
                        id="privacy_policy_accepted"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        // value={validation.values.privacyPolicy}
                        checked={validation.values.privacy_policy_accepted}
                        invalid={
                          validation.touched.privacy_policy_accepted &&
                          validation.errors.privacy_policy_accepted
                            ? true
                            : false
                        }
                      />
                      &nbsp; Acepto la{" "}
                      <a
                        href="https://ditobanx.com/polica-de-privacidad/"
                        target="blank"
                      >
                        política de privacidad{" "}
                      </a>
                      y el procesamiento de mis datos personales
                      {validation.touched.privacy_policy_accepted &&
                      validation.errors.privacy_policy_accepted ? (
                        <FormFeedback type="invalid">
                          {validation.errors.privacy_policy_accepted}
                        </FormFeedback>
                      ) : null}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>

              {/* Botones */}
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {/* <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={onBack}
                >
                  Regresar
                </button> */}
                <Button type="submit" className="btn btn-primary">
                  Siguiente
                </Button>
              </div>
            </CardBody>
          </Card>
        </Form>
      </Container>
    </React.Fragment>
  );
};

export default CheckInformation;
